// extracted by mini-css-extract-plugin
module.exports = {"container":"_aX","centerMenu":"_aY","mainPanel":"_aZ","actions":"_a0","logo":"_a1"};